

// @ts-nocheck

import Vue from "vue";
import check from "./SVGs/Check.vue";
import info from "./SVGs/Info.vue";
import { decode } from "../../../../../../../Overarching Resources/TS/Survey/surveyHelperMethods";

export default Vue.extend({
  data() {
    return {
      optionsLocal: [] as any[],
    };
  },
  props: {
    fieldAddress: Array,
    fieldsEditable: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    options: {
      get: function (): any[] | false {
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: any[] | false): void {
        this.$store.commit("survey/CHANGE_FIELD", {
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
  },
  components: {
    info,
    check,
  },
  methods: {
    addOptn(): void {
      this.optionsLocal.push({
        description: "",
        text: "",
      });
    },
    removeOptn(i: number) {
      this.optionsLocal.splice(i, 1);
    },
  },
  created() {    
    //noconsoleconsole.log('SELECT CREATED, OPTIONS:')
    //noconsoleconsole.log(this.options)
    if (this.options.length === 0) {
      this.optionsLocal = [
        {
          text: '',
          description: ''
        },
        {
          text: '',
          description: ''
        }
      ];
    } else {
      const newOptions = [] as any[];
      this.options.forEach((tp) => {      
          newOptions.push({
            description: tp.description,
            text: tp.text,
          });
      });
      // @ts-ignore
      this.optionsLocal = newOptions;
    }
  },
  watch: {
    optionsLocal: {
      handler(v) {
        //check if encoded values changed, if not reuse them        
        let valToPush = [] as any;
        
        this.optionsLocal.forEach((tpL) => {            
           if (tpL.text.trim())
              valToPush.push({
                text: tpL.text.trim(),
                description: tpL.description.trim(),
              });
        });

        this.options = valToPush;

        setTimeout(() => {
          // @ts-ignore //errors not picked up
          if (this.errors.any()) {
            this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: true});
          } else {
            this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: false});
          }
        }, 1);

      },
      deep: true,
    },
  }
});
